// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".containerHome[data-v-1d9b105c] {\n  width: 100%;\n  height: 100vh;\n  background-color: #999;\n  padding: 15px 15px;\n}\n.containerHome .title[data-v-1d9b105c] {\n  color: #fff;\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 20px;\n}\n.containerHome button[data-v-1d9b105c] {\n  height: 30px;\n  padding: 0 8px;\n  margin: 5px;\n}", ""]);
// Exports
module.exports = exports;
